import { render, staticRenderFns } from "./IncludingResidence.vue?vue&type=template&id=d56bdca2&"
import script from "./IncludingResidence.vue?vue&type=script&lang=ts&"
export * from "./IncludingResidence.vue?vue&type=script&lang=ts&"
import style0 from "./IncludingResidence.vue?vue&type=style&index=0&id=d56bdca2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports